export const tableHeader = (t) => [
  {
    id: 'username',
    type: 'text',
    value: t('user:verifyCodes.table.user'),
  },
  {
    id: 'code',
    type: 'text',
    value: t('user:verifyCodes.table.code'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
